
export default {
	props: {
		count: {
			type: Number,
			required: true,
		},
		tableFields: {
			type: Array,
			required: true,
		},
		currentSort: {
			type: String,
			required: true,
		},
		dictionary: {
			type: Object,
			required: true,
		},
		usePillsLayout: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		topAdHeight() {
			return this.isSmallDevice
				? 68 // TODO, this one is to compensate for the lack of persistent search. When its implemented, we should tweak this value
				: this.$store.state.window.topAdHeight;
		},

		isAnagramResultsPage() {
			return this.$store.getters["navigation/isAnagramResultsPage"];
		},

		isScrabbleResultsPage() {
			return this.$store.getters[
				"navigation/isScrabbleDictionaryResultsPage"
			];
		},

		isPersistentSearch() {
			return this.$store.getters["navigation/isPersistentSearch"];
		},
		stickyTopOffset() {
			const HEADER_BORDER =
				this.isSmallDevice || this.isPersistentSearch ? -1 : 0;
			const OFFSET =
				this.topAdHeight +
				this.$store.state.window.visibleHeaderHeight +
				HEADER_BORDER;

			return {
				top: `${OFFSET}px`,
			};
		},

		summary() {
			if (
				this.$store.getters["navigation/isWordleResultsPage"] ||
				this.$store.getters["navigation/isQuordleResultsPage"]
			) {
				if (this.isSmallDevice) {
					return this.$store.getters["navigation/isWordleResultsPage"]
						? "Wordle Solver"
						: "Quordle Solver";
				}
				return "Words";
			}
			const dictionaryLabel = this.$t(this.dictionary.text);
			const stubs = this.isMediumDeviceOrWider
				? [
						this.count,
						dictionaryLabel,
						this.count === 1 ? "word" : "words",
				  ]
				: [dictionaryLabel];

			return stubs.join(" ");
		},

		hasScoreField() {
			return this.tableFields.includes("score") && !this.usePillsLayout;
		},

		filterOptions() {
			const SORT_OPTIONS = {
				alphaAscending: "alpha",
				alphaDescending: "-alpha",
				points: "score",
			};
			const options = {};

			if (this.hasScoreField) {
				options[SORT_OPTIONS.points] = {
					text: "ResultsSortPointsText",
					titleAttribute: this.$t("ResultsSortPointsTitleAttribute"),
					gaEventID: this.isWordListResultsPage ? 87 : 102,
					selected: this.pageOrderBy === SORT_OPTIONS.points,
					key: SORT_OPTIONS.points,
				};
			}

			options[SORT_OPTIONS.alphaAscending] = {
				text: "ResultsSortAlphabeticalText",
				titleAttribute: this.$t(
					"ResultsSortAlphabeticalTitleAttribute"
				),
				gaEventID: this.isWordListResultsPage ? 86 : 101,
				selected: this.pageOrderBy === SORT_OPTIONS.alphaAscending,
				key: SORT_OPTIONS.alphaAscending,
			};

			options[SORT_OPTIONS.alphaDescending] = {
				text: "ResultsSortInverseAlphabeticalText",
				titleAttribute: this.$t(
					"ResultsSortInverseAlphabeticalTitleAttribute"
				),
				gaEventID: this.isWordListResultsPage ? 88 : 103,
				selected: this.pageOrderBy === SORT_OPTIONS.alphaDescending,
				key: SORT_OPTIONS.alphaDescending,
			};

			return options;
		},
	},
	methods: {
		onDropdownSelect(value) {
			this.$emit("change", value);
		},
	},
};
